import { ReactNode } from 'react';
import { ApiDate, VoiceAppAuth, VoiceAppStatus, VoiceAppUserLimit } from '../../../../../../api/interfaces';

export interface VoiceAppsResponse {
  apps: VoiceAppResponseItem[];
  limits: VoiceAppUserLimit;
}

export interface VoiceAppResponseItem {
  appId: string;
  createDate: ApiDate;
  settings: VoiceAppResponseSettingsItem;
}

export interface VoiceAppResponseSettingsItem {
  appUrl: string;
  authorizationMethod: {
    type: VoiceAppAuth;
    key?: string;
  };
  process: VoiceProcess;
  debugEnabled: boolean;
  status: VoiceAppStatus;
}

export interface Params {
  [key: string]: string;
}

export interface VoiceProcess {
  id: string;
  params: Params;
}

export interface VoiceAppTableRowActions {
  edit: (voiceAppEditData: VoiceAppEditData) => void;
}

export interface VoiceAppTableData {
  id: string;
  createDate: ApiDate;
  appUrl: string;
  status: string;
  debugEnabled: boolean;
  actions: ReactNode;
}

export interface VoiceAppEditData {
  appId: string;
  appUrl: string;
  debugEnabled: boolean;
  authorizationMethod: {
    type: VoiceAppAuth;
    key?: string;
  };
  process: VoiceProcess;
  status: string;
}

export enum BUSINESS_ERRORS {
  'APP_INVALID_URL' = 'APP_INVALID_URL',
  'APP_NOT_FOUND' = 'APP_NOT_FOUND',
  'INVALID_SMS_TEMPLATE' = 'INVALID_SMS_TEMPLATE'
}

export type VoiceAppFormData = VoiceAppEditData;
